import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { onMessageListener } from "../../utils/pushNotification";

import { toastMessage } from "../../utils/toast";
import { clearSession } from "../../utils/initiate";
import * as localizationActions from "../../Redux/Actions/localization";
import NeedHelpModal from "../Ui/NeedHelpModal/NeedHelpModal";
import { biometricCheckout, getByBiometricBooking } from "../../Redux/Actions/biometricAppointment";
import { useLocation, useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import { setHours, setMinutes } from "date-fns";
import CONFIG from "../../config";

const allowedTimes = [];

for (let hour = 9; hour <= 17; hour++) {
  for (let minute of [0, 15, 30, 45]) {
    if (hour === 17 && minute > 30) continue;
    const timeStr = `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
    if (!CONFIG.disabledTimes.includes(timeStr)) {
      allowedTimes.push(setHours(setMinutes(new Date(), minute), hour));
    }
  }
}

const BiometricBooking = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [fcmToken, setFcmToken] = useState("");
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("i18nextLng")
  );

  const [applicationNumber, setApplicationNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [center, setCenter] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [formError, setFormError] = useState("");
  const [uUid, setUuid] = useState("");
  const [pageStatus, setPageStatus] = useState("PAYMENT");
  const [apiCallPassed, setApiCallPassed] = useState(false);
  const [proceedButtonLoading, setProceedButtonLoading] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const applicationNumberParam = queryParams.get("id");
  const [option, setOption] = useState("IsAppointment");
  onMessageListener().then(payload => {
    console.log(payload);
  }).catch(err => console.log('failed: ', err));

  useEffect(() => {
    //To Get English Localizations
    localizationActions
      .localization("EN")
      .then((res) => {
        if (res) {
          setTimeout(() => {
            localStorage.setItem("localEn", JSON.stringify(res));
          }, 10);
        } else {
          localStorage.setItem("localEn", "");
          toastMessage(
            "error",
            (res && res.message) || `Unable to load the eng Localization`
          );
        }
      })
      .catch((err) => {
        err.response?.status === 401 && clearSession(dispatch, history);
      });
    //-----------------------------------------------------------------------------------------------------
    //To Get Arabic Localizations
    localizationActions
      .localization("AR")
      .then((res) => {
        if (res) {
          localStorage.setItem("localAr", JSON.stringify(res));
        } else {
          localStorage.setItem("localAr", "");
          toastMessage(
            "error",
            (res && res.message) || `Unable to load the ar Localization`
          );
        }
      })
      .catch((err) => {
        err.response?.status === 401 && clearSession(dispatch, history);
      });


    if (applicationNumberParam) {
      getByBiometricBooking(applicationNumberParam)
        .then((res) => {
          if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
            const booking = res.data[0];
            setApplicationNumber(booking.applicationNo || "");
            setCustomerName(booking.customerName || "");
            setPhoneNumber(booking.phoneNumber || "");
            setEmail(booking.email || "");
            setUuid(booking.uuid || "");
            setPageStatus(booking.pageType || "PAYMENT");
            setApiCallPassed(true);
            toastMessage("success", "Biometric booking details fetched successfully");
          }
        })
        .catch((err) => {
          setApiCallPassed(false);
          toastMessage("error", "Unable to fetch biometric booking details");
        });
    }
  }, [applicationNumberParam]);

  useEffect(() => {
    if (pageStatus === "LOGS" && applicationNumberParam) {
      history.push(`/biometricTracking?id=${applicationNumberParam}`);
    }
  }, [pageStatus, applicationNumberParam, history]);

  const changeLanguage = (value) => {
    i18n.changeLanguage(value);
    setCurrentLanguage(value);
  };


  const handleProceed = () => {
    if (proceedButtonLoading) return;
    setProceedButtonLoading(true);
    if (
      !applicationNumber.trim() ||
      !customerName.trim() ||
      !phoneNumber.trim() ||
      !email.trim() ||
      !center.trim()
    ) {
      toastMessage("error", "Please Choose the Center");
      setProceedButtonLoading(false);
      return;
    }
    if (option === "IsAppointment" && (!date || !time)) {
      toastMessage("error", "Please choose Date and Time.");
      setProceedButtonLoading(false);
      return;
    }
    setFormError("");
    if (uUid) {
      if (applicationNumberParam) {


        const bookingDetails = {
          id: applicationNumberParam,
          appointmentCenter: Number(center),
          appointmentDate: option === "IsAppointment" ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${time instanceof Date ? time.toTimeString().slice(0, 8) : time
            }` : null,
          appointmentSource: option || ""
        };
        biometricCheckout(bookingDetails).
          then((res) => {
            if (res && res.data) {

              toastMessage("success", "Biometric Checkout successful");
              setProceedButtonLoading(false);
              history.push("/biometricCheckout?id=" + applicationNumberParam, {
                id: applicationNumberParam,
                applicationNumber: applicationNumber,
                customerName: customerName,
                phoneNumber: phoneNumber,
                email: email,
                center: center,
                date: date,
                time: time,
                option: option
              });
            }
          }).catch((err) => {
            setProceedButtonLoading(false);
            toastMessage("error", "Already paid for this booking");
          });
      }
    }
  };


  return (
    <div className="d-flex flex-column  vh-100" style={{ minHeight: "100%", background: "#f8f9fa" }}>
      <div
        className="container-fluid px-3"
        style={{
          width: "100%",
          paddingTop: "1px",
          paddingBottom: "20px",
        }}
      >
        <div className="row align-items-center justify-content-between">

          <div
            className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start align-items-center flex-wrap"
            style={{ gap: "20px" }}
          >
            <img
              src="/Assets/aamer_logistics_logo.png"
              alt="logo"
              style={{
                width: "35vw",
                maxWidth: "130px",
                marginTop: "73px",
              }}
            />
            <img
              src="/Assets/icp-logo.png"
              alt="logo"
              style={{
                width: "35vw",
                maxWidth: "130px",
                height: "auto",
              }}
            />
          </div>

          {/* Language Toggle - Desktop right / Mobile bottom-center */}
          <div
            className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end  mt-3 mt-md-0"
            style={{ gap: "10px" }}
          >
            <span
              style={{
                fontSize: "20px",
                color: "#29235c",
                cursor: "pointer",
                borderBottom: currentLanguage === "english" ? "2px solid" : "0px",
                fontWeight: "bold",
              }}
              onClick={() => changeLanguage("english")}
            >
              EN
            </span>
            <span
              style={{
                fontSize: "20px",
                color: "#29235c",
                fontWeight: "bold",
              }}
            >
              |
            </span>
            <span
              style={{
                fontSize: "20px",
                color: "#29235c",
                cursor: "pointer",
                borderBottom: currentLanguage === "arabic" ? "2px solid" : "0px",
                fontWeight: "bold",
              }}
              onClick={() => changeLanguage("arabic")}
            >
              AR
            </span>
          </div>

        </div>
      </div>
      <div
        className="container"
        style={{
          marginTop: window.innerWidth >= 992 ? "50px" : "20px"
        }}>
        <div className="row">
          <div className="col-12 col-lg-4 mb-4 d-flex flex-column justify-content-between" style={{ minHeight: "100%" }}>
            <div>
              <span
                className=""
                style={{
                  fontSize: "30px",
                  fontWeight: "500",
                  borderBottom: "2px solid #29235c",
                  display: "inline-block",
                  marginBottom: "2%",
                  color: "#29235c",
                }}
              >
                <h1 className="text-2xl font-bold" style={{ fontSize: "2rem", color: "#29235c" }}>{currentLanguage === "arabic" ? " احجز معنا" : "Book With Us"}</h1>
              </span>
              <div className="space-y-2">
                <p className="font-bold"
                  style={{ fontWeight: "bold", fontSize: "18px", color: "#29235c" }}
                >{currentLanguage === "arabic" ? "مرحبًا بك في منصة آمر اللوجستية" : "Welcome to Aamer Logistics Platform"}</p>
                <p className="text-sm"
                  style={{ fontSize: "16px", color: "#29235c", }}
                >{currentLanguage === "arabic" ? ":احجز معنا موعدك البيومتري" : "Book with us your Biometric appointment:"}</p>
                <ol className="list-decimal list-inside text-sm space-y-1" style={{ fontSize: "16px", color: "#29235c" }}>
                  <li style={{ color: "#29235c" }}>{currentLanguage === "arabic" ? "حدد موقع مركز الخدمة المفضل لديك من القائمة" : "Select your preferred Biometric Center from the drop list locations"}</li>
                  <li style={{ color: "#29235c" }}>{currentLanguage === "arabic" ? "حدد التاريخ والوقت" : "Select date & time"}</li>
                  <li style={{ color: "#29235c" }}>{currentLanguage === "arabic" ? " المتابعة مع الدفع" : "Proceed with payment"}</li>
                </ol>
              </div>
            </div>
            <div className="mt-auto pt-4">
              <div className="form-group mb-0">
                <div className="col-12">
                  <span
                    className=""
                    style={{
                      color: "#29235c",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontSize: "18px",
                    }}
                    onClick={() => setShowHelpModal(true)}
                  >
                    {currentLanguage === "arabic" ? "هل تحتاج مساعدة؟" : "Need Help?"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-7">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-6 mb-2">
                <div className="form-group">
                  <label htmlFor="applicationNumber" className="font-weight-bold" style={{ fontSize: "16px", color: "#29235c" }}>
                    {currentLanguage === "arabic" ? ":رقم طلب الهوية الإماراتية" : "Application Number:"}
                  </label>
                  <input
                    type="text"
                    value={applicationNumber}
                    onChange={(e) => setApplicationNumber(e.target.value)}
                    required
                    disabled={applicationNumberParam && apiCallPassed}
                    className="form-control"
                    id="applicationNumber"
                    placeholder={currentLanguage === "arabic" ? "رقم طلب الهوية الإماراتية" : "Enter Application Number"}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 mb-2">
                <div className="form-group">
                  <label htmlFor="customerName" className="font-weight-bold " style={{ fontSize: "16px", color: "#29235c" }}>
                    {currentLanguage === "arabic" ? ":اسم المتعامل" : "Application Name:"}
                  </label>
                  <input
                    type="text"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    disabled={applicationNumberParam && apiCallPassed}
                    required
                    className="form-control"
                    id="customerName"
                    placeholder={currentLanguage === "arabic" ? "اسم المتعامل" : "Enter application Name"}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-6 col-md-6 mb-2">
                <div className="form-group">
                  <label htmlFor="email" className="font-weight-bold" style={{ fontSize: "16px", color: "#29235c" }}>
                    {currentLanguage === "arabic" ? ":البريد الالكتروني" : "Email Address:"}
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder={currentLanguage === "arabic" ? "البريد الالكتروني" : "Enter Email"}
                    value={email}
                    disabled={applicationNumberParam && apiCallPassed}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 mb-2">
                <div className="form-group">
                  <label htmlFor="phoneNumber" className="font-weight-bold" style={{ fontSize: "16px", color: "#29235c" }}>
                    {currentLanguage === "arabic" ? ":رقم الهاتف المتحرك" : "Phone Number:"}
                  </label>
                  <input
                    type="text"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    disabled={applicationNumberParam && apiCallPassed}
                    required
                    className="form-control"
                    id="phoneNumber"
                    placeholder={currentLanguage === "arabic" ? "رقم الهاتف المتحرك" : "Enter Phone Number"}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 mb-2">
                <div className="form-group">
                  <label htmlFor="centerDropdown" className="font-weight-bold" style={{ fontSize: "16px", color: "#29235c" }}>
                    {currentLanguage === "arabic" ? ":اختر المركز" : "Choose the Center:"}
                  </label>
                  <div className="input-group">
                    <select
                      className="form-control"
                      id="centerDropdown"
                      value={center}
                      onChange={(e) => setCenter(e.target.value)}
                      required
                      style={{ cursor: "pointer", backgroundColor: "#29235c", color: "#ffffff" }}
                    >
                      <option value="">{currentLanguage === "arabic" ? "اختر المركز" : "Choose the center"}</option>
                      <option value={1}>{currentLanguage === "arabic" ? "مركز اليلايس لسعادة المتعاملين -دبي" : "Al Yalayis Center-Federal Authority For Identity, Citizenship, Customs & Port Security-Dubai"}</option>
                      {/* <option value={2}>
                        {currentLanguage === "arabic"
                          ? "البرشاء - الهيئة الاتحادية للهوية والجنسية والجمارك وأمن المنافذ - دبي"
                          : "Al Barsha - Federal Authority For Identity, Citizenship, Customs & Port Security - Dubai"}
                      </option>

                      <option value={3}>
                        {currentLanguage === "arabic"
                          ? "الغزال - الهيئة الاتحادية للهوية والجنسية والجمارك وأمن المنافذ - دبي"
                          : "Alghazal - Federal Authority For Identity, Citizenship, Customs & Port Security - Dubai"}
                      </option>

                      <option value={4}>
                        {currentLanguage === "arabic"
                          ? "الراشدية - الهيئة الاتحادية للهوية والجنسية والجمارك وأمن المنافذ - دبي"
                          : "AlRashidiya - Federal Authority For Identity, Citizenship, Customs & Port Security - Dubai"}
                      </option>

                      <option value={5}>
                        {currentLanguage === "arabic"
                          ? "النهدة - الهيئة الاتحادية للهوية والجنسية والجمارك وأمن المنافذ - دبي"
                          : "Al Nahda - Federal Authority For Identity, Citizenship, Customs & Port Security - Dubai"}
                      </option>

                      <option value={6}>
                        {currentLanguage === "arabic"
                          ? "البراحة - الهيئة الاتحادية للهوية والجنسية والجمارك وأمن المنافذ - دبي"
                          : "Al Baraha - Federal Authority For Identity, Citizenship, Customs & Port Security - Dubai"}
                      </option>

                      <option value={7}>
                        {currentLanguage === "arabic"
                          ? "حتا - الهيئة الاتحادية للهوية والجنسية والجمارك وأمن المنافذ - دبي"
                          : "Hatta - Federal Authority For Identity, Citizenship, Customs & Port Security - Dubai"}
                      </option> */}
                      {/* <option value={8}>
                        {currentLanguage === "arabic"
                          ? "مركز النهده لسعادة المتعاملين - الهيئة الاتحادية للهوية والجنسية وأمن الجمارك والمنافذ"
                          : "Al Nahda Customer Happiness Center - Federal Authority for Identity, Citizenship, Customs and Ports Security"}
                      </option> */}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <input
                type="radio"
                id="walkin"
                name="appointmentType"
                value="walkin"
                checked={option === "WalkIn"}
                onChange={() => setOption("WalkIn")}
                style={{
                  accentColor: "#29235c",
                  width: "16px",
                  height: "16px",
                  border: "1px solid #29235c",
                  cursor: "pointer"
                }}
              />
              <label htmlFor="walkin" className="ms-2" style={{ fontSize: "16px", color: "#29235c" }}>
                {currentLanguage === "arabic"
                  ? "خدمة الوصول المباشر دون موعد"
                  : "Walk-in service for direct access"}
              </label>
            </div>

            <div className="mt-1 form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <input
                type="radio"
                id="appointment"
                name="appointmentType"
                value="appointment"
                checked={option === "IsAppointment"}
                onChange={() => setOption("IsAppointment")}
                style={{
                  accentColor: "#29235c",
                  width: "16px",
                  height: "16px",
                  border: "1px solid #29235c",
                  cursor: "pointer"
                }}
              />
              <label htmlFor="appointment" className="ms-2" style={{ fontSize: "16px", color: "#29235c" }}>
                {currentLanguage === "arabic"
                  ? "أو اختر موعدًا"
                  : "Or choose appointment"}
              </label>
            </div>
            {option == "IsAppointment" && (
              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="datePicker" className="font-weight-bold" style={{ fontSize: "16px", color: "#29235c" }}>
                      {currentLanguage === "arabic" ? ":اختر التاريخ" : "Choose the Date:"}
                    </label>
                    <div className="input-group">
                      <DatePicker
                        selected={date}
                        onChange={(val) => setDate(val)}
                        dateFormat="dd-MM-yyyy"
                        minDate={new Date()}
                        filterDate={(date) => {
                          const day = date.getDay();
                          return day !== 0 && day !== 6;
                        }}

                        placeholderText={currentLanguage === "arabic" ? "اختر التاريخ" : "Select Date"}
                        excludeDates={CONFIG.disabledDates}
                        className="form-control"
                        style={{ backgroundColor: "#29235c", color: "#ffffff" }}
                        wrapperClassName="w-100"
                        customInput={<input inputMode="none" />}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="centerDropdown" className="font-weight-bold" style={{ fontSize: "16px", color: "#29235c" }}>
                      {currentLanguage === "arabic" ? ":اختر الوقت" : "Choose the Time:"}
                    </label>
                    <div className="input-group">
                      <DatePicker
                        selected={time}
                        onChange={(val) => setTime(val)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        includeTimes={allowedTimes}
                        timeCaption="Time"
                        dateFormat="hh:mm aa"
                        placeholderText={
                          currentLanguage === "arabic"
                            ? "اختر الوقت"
                            : "Select Time"
                        }
                        className="form-control"
                        wrapperClassName="w-100"
                        customInput={<input inputMode="none" />}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-12 col-sm-6 col-md-6 mb-3">

              </div>

              <div className="col-12 col-sm-6 col-md-6 mb-3">
                <div className="form-group">
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                      type="button"
                      className="btn"
                      style={{
                        backgroundColor: "#29235c",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "18px",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                      disabled={proceedButtonLoading}
                      onClick={handleProceed}
                    >

                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#fff",
                        }}
                      >
                        {currentLanguage === "arabic" ? "المتابعة مع الدفع" : "Proceed With Payment"}
                      </span>
                      {proceedButtonLoading && (
                        <Loader
                          type="Oval"
                          color="#fff"
                          height={20}
                          width={20}
                          style={{ marginLeft: "10px" }}
                        />
                      )}
                    </button>
                  </div>
                </div>
                <p style={{ color: "#D90F15" }}>*{currentLanguage === "arabic" ? "الدفع مطلوب لتأكيد الموعد" : "Payment is required to confirm the appointment"}. <br />
                  {currentLanguage === "arabic" ? "سيتم إرسال رسالة تأكيد بالبريد الإلكتروني عند الدفع بنجاح" : "A confirmation email will be sent upon successful Payment"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showHelpModal && (
        <NeedHelpModal
          t={t}
          handleCancel={() => {
            setShowHelpModal(false);
          }}
          history={history}
          showModal={showHelpModal}
          footerOption1={"Submit"}
          footerOption2={"Cancel"}
          type={"help"}
        >
          {" "}
        </NeedHelpModal>
      )}
    </div>
  );
};

export default BiometricBooking;
